import testimonial from './testimonial'

export default testimonial
